/**
 * Global Feature Flags
 * 
 * Set `ENABLE_EXTRA_FEATURES` to false to hide:
 * - Login & User Registration modal/forms
 * - My Account page & route
 * - Header & Footer links to Blogs & Articles and My Account
 * - "Available 24/7 for support" badge in Footer
 * - "Tour Packages" tab on Home Page
 */
export const FEATURE_FLAGS = {
    ENABLE_EXTRA_FEATURES: false,
};
